// src/client/containers/AppRouter/PrivateRouteB2B.jsx
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getB2bToken,isTokenExpired, logoutB2b } from '../../../b2b/utils/authB2b';

function PrivateRouteB2B({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(routeProps) => {
        // ✅ SSR: pas de window/localStorage → on ne force pas de redirect ici
        if (typeof window === 'undefined') {
          return null;
        }

        const token = getB2bToken();
        const isAuth = !!token && !isTokenExpired(token);
        if (isAuth) {
          return <Component {...routeProps} />;
        }

        logoutB2b();
        return <Redirect to="/b2b-login" />;
      }}
    />
  );
}

export default PrivateRouteB2B;
